"use client";
import toast from "react-hot-toast";
import axios from "axios";
import { useSelector } from "react-redux";
import { AppState } from "@/store/configureStore";

const useFetchFavorites = (setFavoriteList?: any) => {
	const location = useSelector((state: AppState) => state.location);
	const base_url = process.env.NEXT_PUBLIC_BASE_URL;
	const user = useSelector((state: AppState) => state.user);

	const mergeProductWithVariant = (parent: any, variant: any) => {
		const mergedVariant = { ...parent, ...variant, parentId: parent.id };
		delete mergedVariant.variants;
		return mergedVariant;
	};

	const extractProducts = (products: any) => {
		return products.flatMap((item: any) => {
			const parentProduct = { ...item, parentId: item.id };
			delete parentProduct.variants;

			const variantProducts =
				item.variants?.map((variant: any) =>
					mergeProductWithVariant(item, variant)
				) || [];

			return [parentProduct, ...variantProducts];
		});
	};

	const fetchFavorites = async () => {
		try {
			const response = await axios.get(
				`${base_url}/api/favourites/${location?.activeLocation?.id}`,
				{
					headers: {
						Authorization: `Bearer ${user?.token}`,
					},
				}
			);

			setFavoriteList(response?.data?.result);
		} catch (error: string | any) {}
	};
	const fetchSimilar = async (categoryName: string, setProductList?: any) => {
		if (!location?.activeLocation?.id) return;

		try {
			const response = await axios.get(`${base_url}/api/drinks-category`, {
				params: { categoryName, branchId: location.activeLocation.id },
			});
			setProductList(extractProducts(response?.data?.products));
		} catch (error) {}
	};

	const addToFavorites = async (productId: string) => {
		try {
			const response = await axios.post(
				`${base_url}/api/cart/add-to-favorites/${productId}`,
				{},
				{
					headers: {
						Authorization: `Bearer ${user?.token}`,
					},
				}
			);
			setFavoriteList(response?.data?.result);
			toast.remove();
			toast.success("Added to Favorites");
			return true;
		} catch (error: string | any) {
			toast.remove();
			toast.error(`Error: ${error?.response?.data?.error}`);
			return false;
		}
	};
	const removeFromFavorites = async (productId: string) => {
		try {
			await axios.post(
				`${base_url}/api/cart/remove-from-favorites/${productId}`,
				{},
				{
					headers: {
						Authorization: `Bearer ${user?.token}`,
					},
				}
			);
			await fetchFavorites();
			toast.remove();
			toast.success("Removed From Favorites");
			return true;
		} catch (error: string | any) {
			toast.remove();
			toast.error(`Error: ${error?.response?.data?.error}`);
			return false;
		}
	};

	return {
		fetchFavorites,
		addToFavorites,
		fetchSimilar,
		removeFromFavorites,
	};
};

export default useFetchFavorites;
